import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import Spinner from '../components/ui/Spinner';
import { useAuthStore } from '../store/authStore';

export default function LoginPage() {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const checked = useAuthStore((s) => s.checked);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const login = useAuthStore((s) => s.login);
  const clearError = useAuthStore((s) => s.clearError);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  const from =
    (location.state as { from?: string } | null)?.from ?? '/';

  if (checked && user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    try {
      await login(email.trim(), password);
    } catch {
      // error stored in auth store
    }
  };

  return (
    <div className="flex min-h-full flex-col bg-surface">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -left-24 top-0 h-96 w-96 rounded-full bg-kromeka-red/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-kromeka-gray/10 blur-3xl" />
      </div>

      <div className="relative flex flex-1 flex-col items-center justify-center px-6 py-12">
        <div className="mb-10">
          <BrandLogo variant="full" size="hero" />
        </div>

        <div className="w-full max-w-md rounded-2xl border border-border bg-surface-raised/95 p-8 shadow-elevated backdrop-blur-sm">
          <h1 className="text-xl font-bold text-text">Sign in</h1>
          <p className="mt-2 text-sm text-text-muted">
            Simulation Designer — Kromeka
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <label className="block text-sm text-text-muted">
              Email
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field mt-1.5"
                placeholder="you@company.com"
              />
            </label>

            <label className="block text-sm text-text-muted">
              Password
              <input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field mt-1.5"
              />
            </label>

            {error && (
              <div className="alert-danger px-3 py-2 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-2.5 shadow-brand"
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>

        {!checked && (
          <div className="mt-8">
            <Spinner label="Loading…" />
          </div>
        )}
      </div>
    </div>
  );
}
